import { Button, Card, Form, Input, Page, toaster } from 'components/common';
import FormValidator from 'components/FormValidator';
import { isPassword } from 'helpers/rules';
import { useState, useCallback } from 'react';
import { Navigate } from 'react-router-dom';
import { useParams } from 'react-router';
import Api from 'api/Api';

const ResetPassword = () => {
  const [state, setState] = useState({
    password: '',
    passwordRepeat: '',
    pending: false,
    success: false
  });
  const { resetCode } = useParams();

  const handleSubmit = useCallback(
    async (validate, e) => {
      e.preventDefault();
      if (!validate()) {
        return;
      }
      setState({ ...state, pending: true });
      try {
        const user = await Api.resetPasswordWithInvitationCode(
          resetCode,
          state.password
        );
        user && setState({ ...state, pending: false, success: true });
        toaster.success('Password reset successfully!');
      } catch (e) {
        console.error(e);
        setState({ ...state, pending: false });
        toaster.danger('Error resetting password!');
      }
    },
    [resetCode, state]
  );

  const handleChange = (inputName, e) => {
    const { value } = e.target;
    setState({ ...state, [inputName]: value });
  };

  if (state.success)
    return (
      <Navigate
        to={{
          pathname: '/login',
          state: {
            withSuccess:
              'Your password has been reset successfully. You can now login to your account.'
          }
        }}
      />
    );

  return (
    <Page title="Forgot password" container="sm">
      <Card
        className="fadeInAndDown"
        style={{ maxWidth: '30rem', margin: '0 auto' }}>
        <Card.Body>
          <Card.Title>
            <h1>New Password</h1>
            <p>Enter a new password</p>
          </Card.Title>
          <FormValidator
            fields={{
              password: state.password,
              passwordRepeat: state.passwordRepeat
            }}
            rules={{
              password: isPassword,
              passwordRepeat: val =>
                !(val && val === state.password) &&
                'Please confirm your password'
            }}>
            {(errors, validate) => (
              <Form
                onSubmit={e => handleSubmit(validate, e)}
                loading={state.pending}>
                <Form.Group>
                  <Input
                    error={errors.password}
                    name="password"
                    label="Password"
                    value={state.password}
                    onChange={e => handleChange('password', e)}
                    type="password"
                    placeholder="Password"
                    autoComplete="new-password"
                  />
                </Form.Group>
                <Form.Group>
                  <Input
                    error={errors.passwordRepeat}
                    name="passwordRepeat"
                    label="Confirm Password"
                    value={state.passwordRepeat}
                    onChange={e => handleChange('passwordRepeat', e)}
                    type="password"
                    placeholder="Confirm Password"
                    autoComplete="new-password"
                  />
                </Form.Group>
                <Button
                  type="submit"
                  color="primary"
                  loading={state.pending}
                  block>
                  Set new password
                </Button>
              </Form>
            )}
          </FormValidator>
        </Card.Body>
      </Card>
    </Page>
  );
};

export default ResetPassword;
